import { Children } from 'interfaces'

interface Props extends Children {
  className?: string
}
export const TabBar = (props:Props) => {
  const { children, className } = props
  return <div className={`flex flex-wrap gap-6 mb-5 font-semibold text-[15px] sm:text-lg ${className}`}>{children}</div>
}
